import { useState, useEffect } from 'react';
import { API_CONFIG } from '../config/api';

interface CountryResponse {
  cc?: string;
  msg?: string;
}

export const useCountryCode = () => {
  const [countryCode, setCountryCode] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await fetch(API_CONFIG.COUNTRY_CODE_URL);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data: CountryResponse = await response.json();

        if (data.msg === 'ko') {
          throw new Error('API returned error');
        }

        if (data.cc) {
          setCountryCode(data.cc);
        } else {
          throw new Error('No country code received');
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch country code'));
      } finally {
        setLoading(false);
      }
    };

    fetchCountryCode();
  }, []);

  return { countryCode, loading, error };
};
